import isEmpty from 'lodash/isEmpty';

export function getDefaultSelections(data) {
  return new Promise((resolve) => {
    if (isEmpty(data)) {
      resolve({});
    }

    let results = {};
    data.forEach((defaultSelection) => {
      const { defaultSelectionFieldValue } = defaultSelection;

      if (isEmpty(defaultSelectionFieldValue)) {
        return;
      }

      defaultSelectionFieldValue.forEach((selection) => {
        const {
          fieldValue: { field, value },
        } = selection;
        results = {
          ...results,
          [field]: [value],
        };
      });
    });

    resolve(results);
  });
}

export async function reapplyDefaultSelections(app, defaultSelection) {
  const keys = Object.keys(defaultSelection);

  if (!isEmpty(keys)) {
    await Promise.all(
      keys.map(async (key) => {
        await app.field(key).selectValues(defaultSelection[key], false, false);
      }),
    );
  }
}
